import React from "react";
import Flex from "../Flex";
import * as SC from "./SpectralButton.styles";

interface SpectralButtonProps {
  label: JSX.Element | string;
  width?: string;
  height?: string;
  disabled?: boolean;
  onClick: () => void;
}

export const SpectralButton = ({
  label,
  disabled,
  onClick,
  ...rest
}: SpectralButtonProps) => {
  return (
    <SC.SpectralButton
      type="button"
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      <span>
        <Flex align="center" justify="center">
          {label}
        </Flex>
      </span>
    </SC.SpectralButton>
  );
};
